import CocktailVideo from "components/pages/play";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { runQuery } from "queries";

export async function getStaticProps({ locale, params }) {
  return {
    revalidate: 300,
    props: { ...(await serverSideTranslations(locale)) },
    ...(await runQuery("cocktails/single", params)),
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export default CocktailVideo;
